export default __webpack_public_path__ + "static/media/IBM-Django.36b6082e.png";